import { proxy } from 'valtio';
import { AmplitudeEvent, analyticsState, ButtonTag } from './amplitude';

// =============================================================================
// INQUIRY MODE FLAG
// =============================================================================
// When true, the website operates in "inquiry only" mode:
// - Booking routes are blocked and redirect to home
// - All "Book Now" CTAs open the inquiry modal instead
// - Users cannot make reservations, only submit interest
//
// Set to false once inventory is aligned and ready for real bookings
// =============================================================================
export const isInquiryModeEnabled = false;

// =============================================================================
// HIDE PRICES FLAG
// =============================================================================
// When true, prices are hidden across all tent views (cards, modals, pages)
// Set to false once prices are finalized
// =============================================================================
export const arePricesHidden = false;

export interface InquiryPreferences {
  tentType?: string;
  checkIn?: string;
  checkOut?: string;
  guests?: number;
}

export const inquiryModal = proxy({
  isOpen: false,
  preferences: null as InquiryPreferences | null,
});

export const onClose = () => {
  inquiryModal.isOpen = false;
  inquiryModal.preferences = null;
};

export const onOpenInquiry = (preferences?: InquiryPreferences) => {
  inquiryModal.isOpen = true;
  inquiryModal.preferences = preferences ?? null;
  analyticsState.amplitude?.track(AmplitudeEvent.BUTTON_CLICK, {
    buttonTag: ButtonTag.OPEN_INQUIRY,
    ...(preferences && { preferences }),
  });
};
